import Button from "@mui/material/Button";
import { isPositiveNumber } from "et3-type-guards";
import i18n from "../../../../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../../../../core/et3-enhanced-render";
import getKhattabatStore from "../../../../../../stores/khattabat-stores";
import getKhattabatSharedMessagingStore from "../../../../../../stores/khattabat-stores/messaging-stores/conversation-messaging-store";

const KhattabatMarkAsReadButton = withLiteObserverAndTheme<{
  userID: number;
  conversationID: string;
}>((props) => {
  const { userID, conversationID } = props;
  const {
    unreadMessagesCounter,
    getIsCommentsConversation,
    getSelectionPageType
  } = getKhattabatSharedMessagingStore(conversationID);

  const shouldShow =
    isPositiveNumber(unreadMessagesCounter.get()) &&
    !getIsCommentsConversation();

  return !shouldShow ? null : (
    <Button
      variant="contained"
      color="warning"
      onClick={() =>
        getKhattabatStore().setOneOOneMessagesSeen({
          userID,
          pageType: getSelectionPageType()
        })
      }
    >
      {i18n.get("MARK_AS_READ")}
    </Button>
  );
});

export default KhattabatMarkAsReadButton;
